export default "__VITE_ASSET__DyeerZfQ__"